export const SELECTABLE_MATERIAL_ITEM_DETAIL = 'selectable-material-item-detail';
